import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/alert-menu/alert-menu.js';
      import {ObcAckAllVisibleClickEvent} from '@oicl/openbridge-webcomponents/dist/components/alert-menu/alert-menu.js';

      export interface Props {
     hasShelved?: boolean;
     canAckAll?: boolean
   }

      
  
      export type {ObcAckAllVisibleClickEvent} from '@oicl/openbridge-webcomponents/dist/components/alert-menu/alert-menu.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcAlertMenu',
  props: {
    hasShelved: { type: Boolean },
    canAckAll: { type: Boolean }
  },
  emits: ["ack-all-visible-click", "alert-list-click", "silence-click", "go-to-alert-list-click"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onAckAllVisibleClick: (event: ObcAckAllVisibleClickEvent) => emit('ack-all-visible-click', event as ObcAckAllVisibleClickEvent),
onAlertListClick: (event: CustomEvent) => emit('alert-list-click', event as CustomEvent),
onSilenceClick: (event: CustomEvent) => emit('silence-click', event as CustomEvent),
onGoToAlertListClick: (event: CustomEvent) => emit('go-to-alert-list-click', event as CustomEvent)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-alert-menu',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})